import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '../../app.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  isUserName = environment.isUserName;
  constructor(private router: Router, public appConfig: AppConfig) { }

  ngOnInit() {
  }
  onSubmitSuccess(key) {
    this.router.navigate(['login']);
  }
}
